import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link_active",
  "use": "link_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"link_active\"><path fill-rule=\"evenodd\" d=\"M1 9.5C1 7.015 3.012 5 5.496 5h9.008a4.501 4.501 0 0 1 0 9H5.496A4.501 4.501 0 0 1 1 9.5Zm1 0C2 7.567 3.563 6 5.491 6h9.018A3.498 3.498 0 0 1 18 9.5c0 1.933-1.563 3.5-3.491 3.5H5.49A3.498 3.498 0 0 1 2 9.5ZM9 5h2v1H9V5Zm0 8h2v1H9v-1ZM6 9h8v1H6V9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol